import getComingSoon from './coming-soon/index.js';

export default function getBodyPluginConfig(globalData, moduleData, globalizationIns) {
    return {
        render() {
            return [
                getComingSoon.bind(this)(globalData, moduleData)
            ]
        }
    }
}